import React, { useEffect, useState } from 'react';
import SimulationMap from './SimulationMap';
import './SimulationPage.css';
import { API_URL } from '../../config';
import { getLargestPolygonArea } from '../../helpers/coordinates';
import detectorRedIcon from '../../assets/detector-red.png';
import mapboxgl from 'mapbox-gl';
import { rgbToHexFromStep , formatFechaSimulation } from '../../helpers/simulation';
import { authFetch } from '../../utils';

const SimulationPage = () => {
  const [simulations, setSimulations] = useState([]);
  const [selectedSimulation, setSelectedSimulation] = useState(null);
  const [mapRef, setMapRef] = useState(null);
  const [burnedAreaHa, setBurnedAreaHa] = useState(null);


  const fetchSimulationById = async (id) => {
    try {
      const res = await authFetch(`${API_URL}simulation/simulation/${id}`);
      const data = await res.json();
      if (data?.geojson) {
        setSelectedSimulation(data);
      }
    } catch (err) {
      console.error(`Error al cargar la simulación ${id}:`, err);
    }
  };

  useEffect(() => {
    const fetchSimulations = async () => {
        try {
        const res = await authFetch(`${API_URL}simulation/simulations`);
        const data = await res.json();
        if (Array.isArray(data) && data.length > 0) {
            const sorted = data.sort((a, b) => new Date(b.time) - new Date(a.time));
            setSimulations(sorted);

            if (sorted.length > 0) {
            fetchSimulationById(sorted[0].simulationId); // ← carga la más reciente
            }
        }
        } catch (err) {
        console.error('Error cargando simulaciones:', err);
        }
    };
    fetchSimulations();
    }, []);


// 🧠 Efecto para añadir capa al mapa


useEffect(() => {
  if (!mapRef || !selectedSimulation?.geojson) return;

  const map = mapRef;
  const features = [...selectedSimulation.geojson.features].reverse();

  // Elimina las capas de la simulación mostrada anteriormente, ya que sus
  // filtros están atados a los `id` de esos features y no sirven para los nuevos.
  if (map.simulationLayerIds) {
    map.simulationLayerIds.forEach(layerId => {
      if (map.getLayer(layerId)) map.removeLayer(layerId);
    });
  }

  // Añadir o actualizar la fuente
  if (map.getSource('simulation-geojson')) {
    map.getSource('simulation-geojson').setData(selectedSimulation.geojson);
  } else {
    map.addSource('simulation-geojson', {
      type: 'geojson',
      data: selectedSimulation.geojson
    });
  }

  // Volver a crear las capas para los features de la simulación actual
  const newLayerIds = [];
  features.forEach((feature) => {
    const step = feature.properties.step ?? 1;
    const color = feature.properties.fillColor ?? rgbToHexFromStep(step, 6);
    const layerId = feature.properties.id + '-fill';

    map.addLayer({
      id: layerId,
      type: 'fill',
      source: 'simulation-geojson',
      filter: ['==', ['get', 'id'], feature.properties.id],
      paint: {
        'fill-color': color,
        'fill-opacity': 0.4
      }
    });
    newLayerIds.push(layerId);
  });

  map.simulationLayerIds = newLayerIds;
  }, [mapRef, selectedSimulation]);





  useEffect(() => {
  if (!mapRef || !selectedSimulation?.latitude || !selectedSimulation?.longitude) return;

  const map = mapRef;

  // Elimina marcador anterior si existe
  if (map.detectorMarker) {
    map.detectorMarker.remove();
    map.detectorMarker = null;
  }

  const el = document.createElement('img');
  el.src = detectorRedIcon;
  el.alt = 'Detector';
  el.style.width = '32px';
  el.style.height = '32px';

  const marker = new mapboxgl.Marker(el)
    .setLngLat([selectedSimulation.longitude, selectedSimulation.latitude])
    .addTo(map);

  map.detectorMarker = marker;
}, [mapRef, selectedSimulation]);


useEffect(() => {
  return () => {
    if (!mapRef) return;

    const map = mapRef;

    // Elimina capas si existen
    if (map.simulationLayerIds) {
      map.simulationLayerIds.forEach(layerId => {
        if (map.getLayer(layerId)) map.removeLayer(layerId);
      });
      map.simulationLayerIds = null;
    }

    // Elimina fuente si existe
    if (map.getSource('simulation-geojson')) {
      map.removeSource('simulation-geojson');
    }

    // Elimina marcador si existe
    if (map.detectorMarker) {
      map.detectorMarker.remove();
      map.detectorMarker = null;
    }
  };
}, [mapRef]);



  useEffect(() => {
    if (!selectedSimulation?.geojson) return;
    const hectares = getLargestPolygonArea(selectedSimulation.geojson);
    setBurnedAreaHa(hectares);
  }, [selectedSimulation]);

  return (
    <div className="simulation-page">
      <div className="simulation-selector">
        <label htmlFor="simulation-select">Simulación </label>
        <select
            id="simulation-select"
            value={selectedSimulation?.simulationId || ''}
            onChange={(e) => {
                const id = e.target.value;
                const sim = simulations.find(s => s.simulationId === id);
                if (sim?.status === 'completed') {
                fetchSimulationById(id);
                }
            }}
            >
            {simulations.map(sim => (
                <option
                key={sim.simulationId}
                value={sim.simulationId}
                disabled={sim.status !== 'completed'}
                >
                Detector {sim.locationName} ({formatFechaSimulation(sim.time)}) {sim.status !== 'completed' ? '⛔' : ''}
                </option>
            ))}
            </select>

      </div>

      <div className="map-container">
        <SimulationMap onMapLoad={(mapInstance) => setMapRef(mapInstance)} />
        {burnedAreaHa !== null && (
          <div className="map-legend">
            {selectedSimulation?.steps && selectedSimulation?.stepSpan && (
            <div className="map-legend-steps">
              <ul>
                {Array.from({ length: selectedSimulation.steps }, (_, i) => {
                  const step = i + 1;
                  const hours = step * selectedSimulation.stepSpan;
                  const color = rgbToHexFromStep(step, selectedSimulation.steps);
                  return (
                    <li key={step} style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                      <span
                        style={{
                          display: 'inline-block',
                          width: '16px',
                          height: '16px',
                          backgroundColor: color,
                          marginRight: '8px',
                          border: '1px solid #333'
                        }}
                      ></span>
                      {hours} horas
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          Área quemada después de 10 horas<br /> <span style={{ fontSize: 20 }}><strong>{burnedAreaHa.toLocaleString()} hectáreas</strong></span>

          </div>
        )}
      </div>
    </div>
  );
};

export default SimulationPage;
